module.exports = __webpack_public_path__ + "static/media/people.573ce0ea.png";